import React from 'react';

import { URL_LOGIN } from '_constants/urls';
import Home from '_containers/Home';
import './styles.scss';

function HomePage() {
  return <Home loginUrl={URL_LOGIN} />;
}

HomePage.propTypes = {};
HomePage.defaultProps = {};

export default HomePage;
